<script lang="ts">
	import type { VideoBlockData } from '$lib/queries/content/VideoBlockQuery';
	import ExternalVideo from '@atoms/ExternalVideo.svelte';

	let { data }: { data: VideoBlockData } = $props();
</script>

<section class="block:video block:large">
	{#if data.blockTitle}
		{#if data.largeTitle}
			<h2 class="text:h3-alt">{data.blockTitle}</h2>
		{:else}
			<h5 class="text:md">{data.blockTitle}</h5>
		{/if}
	{/if}
	<ExternalVideo data={data.video} />
</section>

<style lang="scss">
	section {
		display: flex;
		flex-direction: column;
		@include largeBlock;

		:global(.ExternalVideo) {
			max-height: 90vh;
		}
	}

	h2 {
		margin-bottom: 1.5rem;
	}

	h5 {
		margin-bottom: 1.5rem;

		@include md {
			margin-left: cols(12, 1, false, true);
			width: cols(12, 6);
		}
	}
</style>
